import controller from './feedback-form.controller';

const template = require('./feedback-form.html');

export default {
    bindings: {
        onCancel: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/help-menu/feedback-form/feedback-form.component.js